import React, { useEffect, useState } from "react";

import "./index.scss";
import { useNavigate } from "react-router-dom";

import { IoEyeOutline } from "react-icons/io5";
import { FiCheckSquare } from "react-icons/fi";

import { BsBan } from "react-icons/bs";
function DevisResponsiveCards({
  blog,
  handleStatus,

  loadData,
}) {
  const [plus, setPlus] = useState(false);
  const navigate = useNavigate();

  const apiUrl = `${process.env.REACT_APP_API_URL}`;
  function getImageURL(id) {
    return `${apiUrl}/devis/${id}/file`;
  }

  return (
    <div id="AbonnementResponsiveCards">
      <div className="card my-4">
        <div className="d-flex ps-3 mt-3 align-items-center ">
          <span className="title me-3">Nom et Prénom:</span>
          <span>{blog?.nom}</span>
        </div>
        <hr />
        <div className="d-flex ps-3 align-items-center ">
          <span className="title me-3"> File:</span>
          <a
            href={getImageURL(blog?._id)}
            target="_blank"
            rel="noopener noreferrer">
            Télécharger
          </a>
        </div>{" "}
        <hr />
        <div className="d-flex ps-3 align-items-center ">
          <span className="title me-3">Email: </span>
          <span>{blog?.email}</span>
        </div>{" "}
        {plus && (
          <div data-aos="fade-down">
            <hr />
            <div className="d-flex ps-3 align-items-center ">
              <span className="title me-3">Téléphone:</span>
              <span>{blog?.tel ? blog?.tel : "Non renseigné"}</span>
            </div>
            <hr />
            <div className="d-flex ps-3 align-items-center ">
              <span className="title me-3">Type Projet:</span>
              <span>{blog?.typeProjet}</span>
            </div>
            <hr />
            <div className="d-flex ps-3 align-items-center ">
              <span className="title me-3">Message:</span>
              <span>{blog?.message}</span>
            </div>
          </div>
        )}
        <hr className="mb-0" />
        <div className="d-flex align-items-center ps-3 pb-3 ">
          <div className="d-flex justify-content-center align-items-center">
            <button
              onClick={() => setPlus(!plus)}
              className="btn btn-link"
              type="button">
              <label className="mx-1">
                <IoEyeOutline style={{ fontSize: "20px" }} />
              </label>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DevisResponsiveCards;
